export enum UserProfileOptionType {
    Department = 'department',
    JobTitle = 'jobTitle',
}

export interface UserProfileOptionListItem {
    id: number;
    name: string;
    code: string;
    type: UserProfileOptionType;
    sort: number;
}
